module.exports = __webpack_public_path__ + "static/media/nvidia.c0bfef19.png";